<style>
#virtualRecipientsRegisterModal .v--modal-box.v--modal {
  min-height: 410px !important;
  min-width: 460px !important;
}
#virtualRecipientsRegisterModal .modal__content {
  overflow-y: hidden !important;
}
#virtualRecipientsRegisterModal .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="virtualRecipientsRegisterModal"
    title="Rejestr projektowanych odbiorców"
    :buttons="[]"
    :register="register"
  >
    <VirtualRecipientsTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import VirtualRecipientsTable from "../../table/VirtualRecipientsTable";

export default {
  components: {
    Modal,
    VirtualRecipientsTable
  },
  data: () => ({
    register: true
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/VirtualRecipientsRegister.vue